import { EventEmitter, Injectable, Output } from '@angular/core';
import { PatientService } from './patient.service';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPatient } from '../models/cnpatient';
import { BecareService } from './becare.service';
import { SNItemFactory } from '../models/snitemfactory';
import { BehaviorSubject, Observable, ObservableLike } from 'rxjs';
import { SNItem } from '../models/snitem';
import { SNItemTableControl, SNItemTableService, SNItemTableServiceCapability } from '../snitem-table/snitem-table-interface';
import { CNConsultation } from '../models/cnconsultation';
import { CNPrescriptionEntry } from '../models/cnprescriptionentry';
import { EHealthService } from './e-health.service';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  private static instance: PrescriptionService = null;
  @Output() updated = new EventEmitter<CNPrescription>();

  constructor(private patient: PatientService, private becare: BecareService,
              private ehealth: EHealthService, private factory: SNItemFactory) {
  }

  public static getInstance(): PrescriptionService {
    return PrescriptionService.instance;
  }

  public getPrescriptions(consultation: CNConsultation): Observable<CNPrescription[]> {
    return new Observable(observer => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.patient.patient.id + '/consultation/' + consultation.id + '/prescriptions').subscribe(result => {
        if (result.success === true && result.prescriptions !== undefined) {
          const factory = new SNItemFactory();
          const prescriptions: CNPrescription[] = [];
          result.prescriptions.forEach(prescription => {
            const prescriptionItem: CNPrescription = factory.itemFromJson(prescription);
            if (prescription.childs) {
              prescription.childs.forEach(entry => {
                const entryItem: CNPrescriptionEntry = factory.itemFromJson(entry);
                prescriptionItem.addChild(entryItem, false);
              });
            }
            prescriptions.push(prescriptionItem);
          });
          observer.next(prescriptions);
        }
      });
    });
  }

  public sendPrescription(prescription: CNPrescription): Observable<CNPrescription> {
    return new Observable(observer => {
      this.ehealth.prescriptionsend(prescription).subscribe(result => {
        if (typeof(result.prescription) === 'undefined') {
          observer.error('No prescription received');
        } else {
          // convert json to item
          const updatedPrescription = this.factory.itemFromJson(result.prescription);
          if (!updatedPrescription) {
            observer.error('Unable to build prescription item');
          } else {
            observer.next(updatedPrescription);
          }
        }
      });
    });
  }

  public smsPrescription(prescription: CNPrescription): Observable<boolean> {
    return new Observable(observer => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.patient.patient.id + '/prescription/' + prescription.id + '/sms', [], prescription.toJson(true), 'put').subscribe(result => {
        if (result.success === true && result.prescription !== undefined) {
          const updatedPrescription = this.factory.itemFromJson(result.prescription);
          if (!updatedPrescription) {
            observer.error('Unable to send prescription');
          } else {
            observer.next(true);
          }
        }
      }, error => {
        observer.error(error.statusText);
      });
    });
  }

  public updatePrescription(prescription: CNPrescription): Observable<CNPrescription> {
    return new Observable(observer => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.patient.patient.id + '/prescription/' + prescription.id, [], prescription.toJson(true), 'put').subscribe(result => {
        if (result.success === true && result.prescription !== undefined) {
          const updatedPrescription = this.factory.itemFromJson(result.prescription);
          if (!updatedPrescription) {
            observer.error('Unable to get prescription entry');
          } else {
            observer.next(updatedPrescription);
            this.updated.emit(updatedPrescription);
          }
        }
      });
    });
  }

  public updatePrescriptionEntry(entry: CNPrescriptionEntry): Observable<CNPrescriptionEntry> {
    return new Observable(observer => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.patient.patient.id + '/prescription/entry/' + entry.id, [], entry.toJson(), 'put').subscribe(result => {
        if (result.success === true && result.entry !== undefined) {
          const updatedEntry = this.factory.itemFromJson(result.entry);
          if (!updatedEntry) {
            observer.error('Unable to get prescription entry');
          } else {
            observer.next(updatedEntry);
          }
        }
      });
    });
  }

  public removePrescriptionEntry(entry: CNPrescriptionEntry): Observable<boolean> {
    return new Observable(observer => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.patient.patient.id + '/prescription/entry/' + entry.id, [], entry.toJson(), 'delete').subscribe(result => {
        if (result.success === true && result.entry !== undefined) {
          observer.next(true);
        }
      });
    });
  }
}
